// extracted by mini-css-extract-plugin
module.exports = {"root":"EditedMarker-root-37w7F typography-detail-1ey0h"};